import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["choice", "questionHeading", "helpHeading"]

  toggle() {
    const heading = this.choiceTarget.checked ? this.helpHeadingTarget : this.questionHeadingTarget
    requestAnimationFrame(() => heading.focus({ preventScroll: true }))
  }
}
